import morse from "./subtitutional/morse";
import morseReversed from "./subtitutional/morse_reverse";
import extMorse from "./subtitutional/extended_morse";

import spider from "./subtitutional/spider";
import firstLast from "./firstlast";
import numbers from "./subtitutional/numbers";
import mobile from "./subtitutional/mobile";
import simpleMove from "./subtitutional/simple_move";
import arrowMove from "./subtitutional/arrow_move";
import vigenerMove from "./subtitutional/vigenere_move";
import reversedAlphabet from "./subtitutional/reversed_alfabet";
import skipLetter from "./skip_letter";
import autokeyd from "./subtitutional/autokeyd";
import chinase from "./graphical/chinase";
import fractions from "./graphical/fractions";
import clearString from "./clear_string";
import fractionsReversed from "./graphical/fractions_reversed";
import hebrewKeyd from "./graphical/hebrew_keyd";
import {drawHebrew, drawHebrewTable, drawChinase, drawChinaseTable} from "@/components/cyphers/helpers/drawSvg";

export const Graphical = 'graphical'

export const Cyphers = {
    MORSE: 'Morseovka',
    MORSEREVERSED: 'Morseovka obrácená',
    EXTMORSE: 'Morseovka - rozšířená',
    SIMPLEMOVE: 'Posun',
    ARROWMOVE: 'Šipka',
    VIGENERMOVE: 'A=.. (Vigenèrova šifra)',
    SPIDER: 'Pavouk',
    FIRSTLAST: 'První poslední',
    FRACTIONS: 'Zlomky',
    FRACTIONSREVERSED: 'Zlomky Obrácené',
    NUMBERS: 'Čísla',
    CHINASE: 'Čínština',
    HEBREW: 'Hebrejština',
    MOBILE: 'Mobilní',
    SKIPLETTER: 'Ob x písmen',
    AUTOKEY: 'Autoklíč',
    REVERSEDALPHABET: 'Obrácené abeceda',
    CLEARSTRING: 'Odebrání diakritiky',
}
export const CyphersType={
    MORSE: '',
    MORSEREVERSED: '',
    EXTMORSE: '',
    SIMPLEMOVE: '',
    ARROWMOVE: '',
    VIGENERMOVE: '',
    SPIDER: '',
    CHINASE: Graphical,
    FIRSTLAST: '',
    // FRACTIONS: Graphical,
    // FRACTIONSREVERSED: Graphical,
    NUMBERS: '',
    MOBILE: '',
    REVERSEDALPHABET: '',
    SKIPLETTER: '',
    AUTOKEY: '',
    CLEARSTRING:'',
    HEBREW: Graphical,
}
export const CypherBeeper={
    MORSE: morse.beepIt,
    MORSEREVERSED: morse.beepIt,
    EXTMORSE: morse.beepIt,
}
export const CypherSeparator={
    MORSE: null,
    MORSEREVERSED: null,
    EXTMORSE: null,
    SPIDER: spider.SEPARATOR,
    NUMBERS: numbers.SEPARATOR,
    ARROWMOVE: arrowMove.SEPARATOR,
}

export const CyphersParams={
    MORSE: 0,
    MORSEREVERSED: 0,
    EXTMORSE: 0,
    SIMPLEMOVE: 1,
    ARROWMOVE: 1,
    VIGENERMOVE: 1,
    SPIDER: 0,
    CHINASE: 1,
    FIRSTLAST: 0,
    FRACTIONS: 0,
    FRACTIONSREVERSED: 0,
    NUMBERS: 0,
    MOBILE: 0,
    REVERSEDALPHABET: 0,
    SKIPLETTER: 2,
    AUTOKEY: 1,
    CLEARSTRING: 0,
    HEBREW: 1,
}

export const CyphersParamsPlaceholder={
    MORSE: 0,
    MORSEREVERSED: 0,
    EXTMORSE: 0,
    SIMPLEMOVE: ["O kolik posunout? (číslo)"],
    ARROWMOVE: ["Šipka pro posun (čísla)"],
    VIGENERMOVE: ["Klíč pro šifru (písmena)"],
    SPIDER: 0,
    CHINASE: ['Klíč (nepovinný)'],
    FIRSTLAST: 0,
    FRACTIONS: 0,
    FRACTIONSREVERSED: 0,
    NUMBERS: 0,
    MOBILE: 0,
    REVERSEDALPHABET: 0,
    SKIPLETTER: ['Ob x písmen (1)', 'Falešná zpráva (nepovinná)'],
    AUTOKEY: ['První klíčovací znak'],
    CLEARSTRING: 0,
    HEBREW: ['Klíč (nepovinný)'],
}
export const CyphersParamsValidation={
    SIMPLEMOVE: [/\d+/g],
    ARROWMOVE: [/(\d+[ ,]*)+/],
    VIGENERMOVE: [/[a-zA-Z]+/],
}

export const CyphersCharMissing = {
    MORSE: null,
    MORSEREVERSED: null,
    EXTMORSE: null,
    SIMPLEMOVE: null,
    ARROWMOVE: null,
    VIGENERMOVE: null,
    SPIDER: ['ch','q','w'],
    CHINASE: ['ch','q'],
    FIRSTLAST: [],
    FRACTIONS: ['ch','q'],
    FRACTIONSREVERSED: ['ch','q'],
    NUMBERS: null,
    MOBILE: ['ch'],
    REVERSEDALPHABET: null,
    SKIPLETTER: null,
    AUTOKEY: null,
    CLEARSTRING: null,
    HEBREW: null,
}
export const CyphersChIsChar = {
    MORSE: null,
    MORSEREVERSED: null,
    EXTMORSE: null,
    SIMPLEMOVE: false,
    ARROWMOVE: false,
    VIGENERMOVE: false,
    SPIDER: false,
    CHINASE: false,
    FIRSTLAST: false,
    FRACTIONS: false,
    FRACTIONSREVERSED: false,
    NUMBERS: false,
    MOBILE: null,
    REVERSEDALPHABET: false,
    SKIPLETTER: false,
    AUTOKEY: false,
    CLEARSTRING: false,
    HEBREW: true,
}
export const CyphersCharCheckMissing = {
    MORSE: false,
    MORSEREVERSED: false,
    EXTMORSE: false,
    SIMPLEMOVE: false,
    ARROWMOVE: false,
    VIGENERMOVE: false,
    SPIDER: true,
    CHINASE: true,
    FIRSTLAST: false,
    FRACTIONS: true,
    FRACTIONSREVERSED: true,
    NUMBERS: false,
    MOBILE: true,
    REVERSEDALPHABET: false,
    SKIPLETTER: false,
    AUTOKEY: false,
    CLEARSTRING: false,
    HEBREW: false,
}
export const CyphersBothway = {
    MORSE: '',
    MORSEREVERSED: '',
    EXTMORSE: '',
    SIMPLEMOVE: '',
    ARROWMOVE: '',
    VIGENERMOVE: '',
    SPIDER: '',
    CHINASE: 'cypher',
    FIRSTLAST:'',
    FRACTIONS:'',
    FRACTIONSREVERSED:'',
    NUMBERS:'',
    MOBILE:'',
    REVERSEDALPHABET:'',
    SKIPLETTER:'',
    AUTOKEY:'',
    CLEARSTRING:'cypher',
    HEBREW:'cypher',
}

export const methods = {
    MORSE: morse,
    MORSEREVERSED: morseReversed,
    EXTMORSE: extMorse,
    SIMPLEMOVE: simpleMove,
    ARROWMOVE: arrowMove,
    VIGENERMOVE: vigenerMove,
    SPIDER: spider,
    CHINASE: chinase,
    FIRSTLAST: firstLast,
    FRACTIONS: fractions,
    FRACTIONSREVERSED: fractionsReversed,
    NUMBERS: numbers,
    MOBILE: mobile,
    REVERSEDALPHABET: reversedAlphabet,
    SKIPLETTER: skipLetter,
    AUTOKEY: autokeyd,
    CLEARSTRING: clearString,
    HEBREW: hebrewKeyd,
}
export const drawMethod = {
    // CHINASE: drawChinase,
    // HEBREW: drawHebrew,
    HEBREW: drawHebrew,
    CHINASE: drawChinase,
}
export const drawDecryptTableMethod={
    HEBREW: drawHebrewTable,
    CHINASE: drawChinaseTable,
}

export default {
    Cyphers,
    CyphersType,
    CypherBeeper,
    CypherSeparator,
    CyphersCharMissing,
    CyphersCharCheckMissing,
    CyphersParamsPlaceholder,
    CyphersParams,
    CyphersParamsValidation,
    CyphersChIsChar,
    CyphersBothway,
    Graphical,
    drawMethod,
    drawDecryptTableMethod,
    methods
}